export const dummyDashboardData = {
  stats: {
    pending: 12,
    resolved: 45,
    all: 57,
    agents: 5,
    clients: 42,
  },
  callDetails: {
    totalCalls: 128,
    avgDuration: "2m 15s",
    totalDuration: "4h 48m",
  },
  ticketType: {
    label: ["Sale", "Information", "Complaint", "Billing"],
    value: [25, 15, 10, 7],
  },
  tickets: [
    {
      _id: "dummy1",
      category: "Sale",
      status: "Resolved",
      assignee: "Agent",
      createdAt: new Date().toISOString(),
    },
    {
      _id: "dummy2",
      category: "Complaint",
      status: "Pending",
      assignee: "Client",
      createdAt: new Date().toISOString(),
    },
  ],
};

export const dummyLeads = [
  {
    _id: "dummy_lead_1",
    phoneNumber: "+971 50 123 4567",
    name: "John Doe (Demo)",
    city: "Dubai",
    email: "john@example.com",
    source: "Facebook Ads",
    title: "Real Estate Inquiry",
    locationID: "DXB-001",
    contactID: "CON-789",
    createdAt: new Date(Date.now() - 3600000).toISOString(),
    sla: { status: "On Time" },
    callLogs: [
      {
        callId: "call_101",
        user: "Agent Sarah",
        callDate: "2026-02-18",
        calls_time: "10:30:00",
        mobile: "+971 50 123 4567",
        sub_disposition: "Answered",
        childDisposition: "Interested",
        comment: "Client is interested in 2BHK units.",
        recording_url: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3",
      },
    ],
  },
  {
    _id: "dummy_lead_2",
    phoneNumber: "+971 55 987 6543",
    name: "Jane Smith (Demo)",
    city: "Abu Dhabi",
    email: "jane@demo.ae",
    source: "Google Search",
    title: "Software License",
    locationID: "AUH-005",
    contactID: "CON-456",
    createdAt: new Date(Date.now() - 86400000).toISOString(),
    sla: { status: "Overdue" },
    callLogs: [
      {
        callId: "call_102",
        user: "Agent Mike",
        callDate: "2026-02-17",
        calls_time: "14:15:00",
        mobile: "+971 55 987 6543",
        sub_disposition: "Missed",
        childDisposition: "Follow up",
        comment: "Called back, no answer.",
        recording_url: null,
      },
    ],
  },
];

export const dummyCallLogs = [
  {
    _id: "cl1",
    status: "Answered",
    payload: {
      callId: "10001",
      calls_agent_number: "+971 50 111 2222",
      user: "Sarah Connor",
      callDate: new Date().toISOString(),
      calls_time: "09:00:00",
      timeDuration: "120",
      mobile: "+971 50 123 4567",
      calls_direction: "Inbound",
      sub_disposition: "Answered",
      childDisposition: "Interested",
      comment: "Client interested in premium plan.",
      location: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3",
    },
  },
  {
    _id: "cl2",
    status: "Missed",
    payload: {
      callId: "10002",
      calls_agent_number: "+971 50 333 4444",
      user: "Mike Ross",
      callDate: new Date(Date.now() - 3600000).toISOString(),
      calls_time: "10:30:00",
      timeDuration: "0",
      mobile: "+91 98765 43210",
      calls_direction: "Outbound",
      sub_disposition: "Missed",
      childDisposition: "Follow up",
      comment: "Voicemail left.",
      location: null,
    },
  },
  {
    _id: "cl3",
    status: "Answered",
    payload: {
      callId: "10003",
      calls_agent_number: "+971 50 555 6666",
      user: "Harvey Specter",
      callDate: new Date(Date.now() - 7200000).toISOString(),
      calls_time: "11:45:00",
      timeDuration: "450",
      mobile: "+44 20 7946 0958",
      calls_direction: "Inbound",
      sub_disposition: "Answered",
      childDisposition: "Sale Closed",
      comment: "Contract signed during call.",
      location: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-2.mp3",
    },
  },
  {
    _id: "cl4",
    status: "Failed",
    payload: {
      callId: "10004",
      calls_agent_number: "+971 50 777 8888",
      user: "Donna Paulsen",
      callDate: new Date(Date.now() - 10800000).toISOString(),
      calls_time: "13:15:00",
      timeDuration: "0",
      mobile: "+1 202 555 0123",
      calls_direction: "Outbound",
      sub_disposition: "Failed",
      childDisposition: "Wrong Number",
      comment: "Agent reported wrong number.",
      location: null,
    },
  },
  {
    _id: "cl5",
    status: "Answered",
    payload: {
      callId: "10005",
      calls_agent_number: "+971 50 999 0000",
      user: "Louis Litt",
      callDate: new Date(Date.now() - 14400000).toISOString(),
      calls_time: "15:00:00",
      timeDuration: "185",
      mobile: "+971 50 888 7777",
      calls_direction: "Inbound",
      sub_disposition: "Answered",
      childDisposition: "Information Needed",
      comment: "Sent documents via email.",
      location: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-3.mp3",
    },
  },
];

export const dummySubDispositionChart = {
  "Interested": 15,
  "Follow up": 10,
  "Sale Closed": 8,
  "Wrong Number": 5,
  "Information Needed": 12,
};
